import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions} from "../../constants";
import {IS_QKB_UI} from "../../../../../config";

export default class TowelBar extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'towel_bar';
    this.partName = 'Towel Bar';
    this.translateId = "visualizer.bathroom.accessories.towel_bar";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  navigationSubItems(...props) {
    if (IS_QKB_UI) {
      return this.navigationSubItemsSimple(...props)
    }
    return super.navigationSubItems(...props);
  }
}
